import { Empty, Form } from 'antd';
import { useContext } from 'react';

import { PictureList } from 'app/components/commons/ImageUploader/PictureList/PictureList';
import { PictureGallery } from 'app/components/commons/Package/Pictures/PictureGallery';
import {
  DEFAULT_KIND,
  pictureToPictureView,
  pictureViewToPicture,
} from 'app/components/pages/Experiences/Common/_components/Medias/_components/utils';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import type { Picture } from 'app/typings';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';

import './Discover.scss';

type SingleMode = {
  multiple?: false;
  value?: PictureView;
};

type MultipleMode = {
  multiple: true;
  value?: PictureView[];
};

type FormPictureFieldProps = {
  name?: string | (string | number)[];
  sectionTitle: string;
  hotelId?: number;
  maxPictures?: number;
} & (SingleMode | MultipleMode);

export const FormPictureField = ({
  name,
  sectionTitle,
  hotelId,
  maxPictures,
  multiple,
  value,
}: FormPictureFieldProps) => {
  const { isEditMode } = useContext(ViewEditModeContext);

  const getValueProps = multiple
    ? (val: PictureView[]) => ({ value: (val ?? []).map(pictureViewToPicture) })
    : (val: PictureView) => ({ value: val ? [pictureViewToPicture(val)] : [] });

  const getValueFromEvent = multiple
    ? (pictures: Picture[]) => pictures.map(pictureToPictureView)
    : (pictures: Picture[]) =>
        pictures?.[0] ? pictureToPictureView(pictures[0]) : null;

  const pictures = multiple
    ? (value as PictureView[] | undefined)?.map(pictureViewToPicture)
    : value
      ? [pictureViewToPicture(value as PictureView)]
      : undefined;

  return (
    <Form.Item
      name={name}
      valuePropName="value"
      getValueProps={getValueProps}
      getValueFromEvent={getValueFromEvent}
    >
      {isEditMode ? (
        <PictureGallery
          sectionTitle={sectionTitle}
          hotelId={hotelId}
          picturesCategories={[
            { name: 'Cover', type: 'cover' },
            { name: 'Official', type: 'official' },
            { name: 'Sourcing', type: 'sourcing' },
          ]}
          kind={DEFAULT_KIND}
          previewable
          editable
          removable
          draggable
          maxPictures={maxPictures}
        />
      ) : pictures?.length ? (
        <PictureList pictures={pictures} uploadingItems={{}} previewable />
      ) : (
        <span className="empty-list">
          <Empty />
        </span>
      )}
    </Form.Item>
  );
};
